import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/login/login.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { OidcClientService } from '@upmc-healthplan-npm/oidc-client';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    standalone: false
})
export class LoginComponent implements OnInit, OnDestroy {
  unsubscribe = new Subject();
  timeOut = JSON.parse(sessionStorage.getItem('timeOut'));
  constructor(
    private router: Router,
    private loginService: LoginService,
    private oidc: OidcClientService
  ) { }

  ngOnInit() {
    if (this.timeOut) {
      this.router.navigate(['/sign-out']);
    } else {
      this.loginService.signIn()
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(isSignedIn => {
          if (isSignedIn) {
            this.router.navigate(['/main/new-sales-dashboard']);
          } else {
            this.oidc.signIn();
          }
        });
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
  }
}
